import { useNavigate } from 'react-router-dom';
import { Icon } from '@/ui/icons/Icon';
import { useQuestionnaire } from '../../hooks/useQuestionnaire';
import { routes } from '@/routes/routes';
import type { FinancialNeedOption } from '../../types/questionnaire';
import styles from './FinancialNeedPage.module.scss';

const OPTIONS: { value: FinancialNeedOption; label: string; icon?: string }[] = [
  { value: 'personal_expenses', label: 'Cheltuieli personale' },
  { value: 'credit_line', label: 'Linie de credit', icon: '💳' },
  { value: 'medical_emergency', label: 'Urgență medicală', icon: '🩺' },
  { value: 'car', label: 'Vreau o mașină', icon: '🚗' },
  { value: 'mortgage', label: 'Credit ipotecar', icon: '🏠' },
  { value: 'credit_score', label: 'Creștere scor', icon: '📈' },
  { value: 'other', label: 'Altceva' },
];

function FinancialNeedPage() {
  const navigate = useNavigate();
  const { saveFinancialNeed, isSavingFinancialNeed } = useQuestionnaire();

  const handleSelect = async (value: FinancialNeedOption) => {
    await saveFinancialNeed(value);
    navigate(routes.questionnaire.base);
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          Care sunt nevoile{'\n'}tale financiare?
        </h1>
      </div>

      <div className={styles.options}>
        {OPTIONS.map(({ value, label, icon }) => (
          <button
            key={value}
            className={styles.option}
            disabled={isSavingFinancialNeed}
            onClick={() => handleSelect(value)}
          >
            {icon && <span className={styles.optionIcon}>{icon}</span>}
            <span className={styles.optionText}>{label}</span>
            <span className={styles.optionArrow}>
              <Icon name="arrow-right" size={24} />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default FinancialNeedPage;
